// extracted by mini-css-extract-plugin
module.exports = {"title":"Menus__title___ij_3Z","rule":"Menus__rule___1Ax5v"};